document.addEventListener('DOMContentLoaded', function () {
  const slideshows = document.querySelectorAll('.custom-slideshow');

  slideshows.forEach(slideshow => {
    const itemsContainer = slideshow.querySelector('.custom-slideshow__items');
    const items          = slideshow.querySelectorAll('.custom-slideshow__item');
    const prevBtn        = slideshow.querySelector('.prev-btn');
    const nextBtn        = slideshow.querySelector('.next-btn');
    const playPauseBtn   = slideshow.querySelector('.play-pause-btn');
    const iconPlay       = slideshow.querySelector('.icon-play');
    const iconPause      = slideshow.querySelector('.icon-pause');
    const ringFill       = slideshow.querySelector('.progress-ring__fill');

    const isAutoplayAttr = itemsContainer.getAttribute('data-autoplay') === 'true';
    const speed          = parseInt(itemsContainer.getAttribute('data-speed')) || 5000;

    // --- Configuração do SVG Ring ---
    // r="18" no viewBox 40x40 → circunferência = 2π × 18 ≈ 113.1
    const RADIUS = 18;
    const CIRC   = 2 * Math.PI * RADIUS; // 113.097...

    if (ringFill) {
      ringFill.style.strokeDasharray  = CIRC;
      ringFill.style.strokeDashoffset = CIRC; // começa vazio (0% preenchido)
    }

    // --- Estado ---
    let currentIndex = 0;
    let isPlaying    = isAutoplayAttr;

    // requestAnimationFrame
    let rafId       = null;
    let startTime   = null;   // timestamp do início do slide atual
    let pausedAt    = 0;      // quanto tempo já passou quando pausou (ms)

    // --- Funções do Ring ---

    function setRingProgress(fraction) {
      // fraction: 0 = vazio, 1 = completo
      if (!ringFill) return;
      ringFill.style.strokeDashoffset = CIRC * (1 - fraction);
    }

    function ringLoop(timestamp) {
      if (!startTime) startTime = timestamp;

      const elapsed  = (timestamp - startTime) + pausedAt;
      const fraction = Math.min(elapsed / speed, 1);

      setRingProgress(fraction);

      if (fraction < 1) {
        rafId = requestAnimationFrame(ringLoop);
      } else {
        // Chegou ao fim: troca o slide e reinicia o anel
        pausedAt  = 0;
        startTime = null;
        goToSlide(currentIndex + 1);
        rafId = requestAnimationFrame(ringLoop);
      }
    }

    function startRing() {
      cancelAnimationFrame(rafId);
      startTime = null;
      rafId = requestAnimationFrame(ringLoop);
    }

    function pauseRing() {
      cancelAnimationFrame(rafId);
      rafId = null;
      // Guarda quanto tempo passou para retomar do mesmo ponto
      if (startTime !== null) {
        pausedAt += performance.now() - startTime;
        startTime = null;
      }
    }

    function resetRing() {
      cancelAnimationFrame(rafId);
      rafId     = null;
      startTime = null;
      pausedAt  = 0;
      setRingProgress(0);
    }

    // --- Navegação ---

    function goToSlide(index) {
      if (index < 0) index = items.length - 1;
      if (index >= items.length) index = 0;

      itemsContainer.style.transform = `translateX(-${index * 100}%)`;
      currentIndex = index;
    }

    // --- Play / Pause ---

    function play() {
      isPlaying = true;
      setIcons(true);
      startRing();
    }

    function pause() {
      isPlaying = false;
      setIcons(false);
      pauseRing();
    }

    function setIcons(playing) {
      if (!iconPlay || !iconPause) return;
      iconPlay.style.display  = playing ? 'none'  : 'flex';
      iconPause.style.display = playing ? 'flex'  : 'none';
    }

    // --- Eventos ---

    if (items.length <= 1) {
      if (playPauseBtn) playPauseBtn.closest('.play-pause-wrap').style.display = 'none';
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    if (playPauseBtn) {
      playPauseBtn.addEventListener('click', () => {
        if (isPlaying) {
          pause();
        } else {
          play();
        }
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        resetRing();
        goToSlide(currentIndex - 1);
        if (isPlaying) startRing();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        resetRing();
        goToSlide(currentIndex + 1);
        if (isPlaying) startRing();
      });
    }

    // --- Inicialização ---
    goToSlide(0);

    if (isPlaying) {
      setIcons(true);
      startRing();
    } else {
      setIcons(false);
      setRingProgress(0);
    }
  });
});